import { createAction } from '@reduxjs/toolkit';

export const GET_TRANSACTION_DETAILS_REQUEST = 'GET_TRANSACTION_DETAILS_REQUEST';

export const getTransactionDetailsRequest = createAction('GET_TRANSACTION_DETAILS_REQUEST', (transactionId, token) => {
    return {
        payload: { transactionId, token }
    }
});

export const getTransactionDetailsSuccess = createAction('GET_TRANSACTION_DETAILS_SUCCESS', (transactionId, data) => {
    return {
        payload: { transactionId, data }
    }
});

export const getTransactionDetailsFailure = createAction('GET_TRANSACTION_DETAILS_FAILURE', (transactionId, error) => {
    return {
        payload: { transactionId, error }
    }
});

export const getViewLocationDetailsRequest = createAction('GET_VIEW_LOCATION_DETAILS_REQUEST', (brandId) => {
    return {
        payload: { brandId }
    }
});

export const getViewLocationDetailsSuccess = createAction('GET_VIEW_LOCATION_DETAILS_SUCCESS', (data) => {
    return {
        payload: { data }
    }
});

export const getViewLocationDetailsFailure = createAction('GET_VIEW_LOCATION_DETAILS_FAILURE', (error) => {
    return {
        payload: { error }
    }
});
